import React from "react";
import dayjs from "dayjs";
import { Grid, Typography } from "@mui/material";

const Footer: React.FC = () => {
    return (
        <div style={{ position: "relative", bottom: 0, width: "100%" }}>
            <br /><br /><br /><br />
            <div style={{ padding: "0.8% 1%", backgroundColor: "black", color: "white", display: "flex", flexDirection: "row" }}>
                <Grid container flexDirection={'row'}>
                    <Grid md={4} item>
                        <Typography>
                            Gigabyte Distribuzione S.p.A.
                        </Typography>
                        <Typography>
                            IT 02987721202
                        </Typography>
                    </Grid>
                    <Grid md={4} item>
                        <Typography>Capitale Sociale: eur 400.000 i.v.</Typography>
                        <Typography>
                            <a href="mailto:info@gigabytedistribuzione.it">info@gigabytedistribuzione.it</a>
                        </Typography>
                    </Grid>
                    <Grid md={4} item>
                        <Typography>Via Cicogna 111-113, 40068 San Lazzaro di Savena (BO)</Typography>
                        <Typography>Via Bruno Corti 13, 25089 Villanuova sul Clisi (BS)</Typography>
                    </Grid>
                </Grid>
            </div>
            <div style={{ padding: "0.5%", fontSize: "14px", color: "white", backgroundColor: "#191919", textAlign: "center" }}>
                Designed by <a target="_blank" href="https://upensrl.com/">UPEN SRL</a> (di <a style={{ color: "red" }} href="https://nicmacompany.com/" target="_blank">Nicma Company</a>) | © {dayjs().year()} All Rights Reserved | 2009-{dayjs().year()} Versione B2B 3.11
            </div>
        </div>
    );
};

export default Footer;
